var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container azSize" },
      [
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("H1", { staticClass: "pageTitle isPoppins" }, [_vm._v("About")]),
        _vm._v(" "),
        _c("div", { staticClass: " top15  accSettingsForm aboutText" }, [
          _c("div", { staticClass: "has-text-right" }),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We are like you, entrepreneurs looking to engage audiences with our digital offerings.  But competition is ferocious.  While online users have come to \n            expect ease of use and agility, the sheer size of the competitive landscape has tended to complicate what should really be simple. In short, as competition for attention has risen, consumers' \n            attention spans have decreased."
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v("This is why we created "),
            _c("b", { staticClass: "has-text-warning" }, [_vm._v("Slink")]),
            _vm._v(", the “Quick Connection Platform.”  "),
            _c("b", { staticClass: "has-text-warning" }, [_vm._v("Slink")]),
            _vm._v(
              " is the result of decades of experience building solutions for different companies and institutions that required "
            ),
            _c("b", [_vm._v("connection")]),
            _vm._v(
              " to their \n            audiences.  Our objective is to simplify this complex task."
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v("We have designed "),
            _c("b", { staticClass: "has-text-warning" }, [_vm._v("Slink")]),
            _vm._v(
              " to offer a simple and effective service, allowing any user to lease one or many keywords that can then be used as shortcuts to reach any web destination.  \n            "
            ),
            _c("b", { staticClass: "has-text-warning" }, [_vm._v("Slink")]),
            _vm._v(
              " allows you to choose words that are important to you and leverage them in your communications strategy to drive traffic efficiently."
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you would like your ads on TV, radio, press, billboards or social media to carry a concrete and memorable call to action, you can now use the words you want \n            instead of a potentially confusing and complicated URL. "
            ),
            _c("b", { staticClass: "has-text-warning" }, [_vm._v("Slink")]),
            _vm._v(
              ' takes care of this, with full control remaining in your hands. We are reducing the dependency on a "clickable" URL in \n            favor of something that can be '
            ),
            _c("b", [_vm._v("remembered")]),
            _vm._v(
              " and used quickly and efficiently to reach an online destination."
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Over many years, we built many sites and applications and were always looking for something as effective as this to propel our client’s success.  \n            We never found a practical and secure way of doing it. So we decided to build it for ourselves, but also make it available for others to use."
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v("Now you can "),
            _c("b", [_vm._v("own your words")]),
            _vm._v(" and turn them into actions.\n          ")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br")
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c11fd19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c11fd19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = null
// module chunks = 